<div class="container mt-3 mb-3" [hidden]="message === '' && errors.length === 0">
    <div class="text-danger text-center">
        <p>
            {{message}}
        </p>
        <ul style="list-style:none;">
            <li *ngFor="let error of errors">{{error}}</li>
        </ul>
    </div>
</div>